import React from 'react';
import { TimelineDot } from '@mui/lab';
import { selectUserColor } from '../../../redux/selectors/authSelectors';
import PolarisIcon from '../PolarisIcon';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';

const UserDot = () => {
  const userColor = useAppSelector(selectUserColor);

  return (
    <StyledTimelineDot sx={{ color: userColor, borderColor: userColor }}>
      <PolarisIcon icon="user" style={{ color: userColor || undefined }} />
    </StyledTimelineDot>
  );
};

export default UserDot;

const StyledTimelineDot = styled(TimelineDot)`
  height: 35px;
  width: 35px;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  line-height: 1;
  border-width: 2px;
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};
  position: relative;

  & > svg {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 1.2rem;
  }
`;
